import { Injectable } from '@angular/core';
import { CompaniesData } from '../interfaces/companies-data.interface';
import { UserReadableResource } from 'src/app/api/interfaces/localized-resource.interface';
import { AbstractApiV2Service } from '../../../api/services/abstract-api-v2.service';
import { OrganizationData } from '../../organizations/interfaces/OrganizationData';
import { CompaniesOnboardingIssuesDataInterface } from '../../admin/companies-onboarding-issues/interfaces/companies-onboarding-issues-data.interface';
import { ApiCreateSingleResponse } from '../../../api/interfaces/api-create-single-response.interface';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CompanyDetailsInterface, Integration, IntegrationsCount } from '../interfaces/company-details.interface';

@Injectable({
    providedIn: 'root',
})
export class CompaniesService extends AbstractApiV2Service<CompaniesData> implements UserReadableResource {
    public LocalizedResourceName = $localize`company`;
    public LocalizedPluralResourceName = $localize`companies`;

    protected resourceName = 'companies';

    public resyncCompany(company: OrganizationData | CompaniesOnboardingIssuesDataInterface) {
        const formData = new FormData();
        formData.append('resync', 'true');
        return this.createSingle(formData, company.id.toString());
    }

    public resyncCompanyWithSalesforce(company: OrganizationData | CompaniesOnboardingIssuesDataInterface) {
        return this.http
            .post<ApiCreateSingleResponse>(`/v2/tickets/sync/${company.id.toString}`, null)
            .pipe(catchError(this.convertToUserReadableError.bind(this)));
    }

    public approveCompany(company: OrganizationData | CompaniesOnboardingIssuesDataInterface) {
        const formData = new FormData();
        return this.createSingle(formData, `cz/${company.id.toString()}/approve`);
    }

    public toggleStatus(companyId: string): Observable<object> {
        const formData = new FormData();
        return this.createSingle(formData, `cz/${companyId}/toggle-status`);
    }

    public deleteCompany(company: OrganizationData | CompaniesOnboardingIssuesDataInterface) {
        return this.deleteSingle(`cz/${company.id.toString()}`);
    }

    public getLicense(companyId: string): Observable<any> {
        return this.getSingle(`${companyId}/license`);
    }

    public getCompanyDetails(uuid: string): Observable<CompanyDetailsInterface> {
        return this.http.get<CompanyDetailsInterface>('/v2/companies/' + uuid);
    }

    public getCompanyIntegrationCount(uuid: string): Observable<IntegrationsCount> {
        return this.http.get<IntegrationsCount>('/v2/companies-integrations-count');
    }
}
